import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class EpubPreviewDto {
  @Field()
  url!: string
}
